import fetchRequest from "./index";

import { GET_HEADER_NAV_MAIN, GET_HEADER, GET_FOOTER_MENU, GET_RGPBANNER, GET_REMARK, GET_REMARKANDADDITIONALREMARK, GET_GoingReport } from "@/app/utils/request/CMSquery";

import { GET_JOCKEYRANKING, GET_TRAINERRANKING, GET_JOCKEYSRIDES, GET_TRAINERSENTRIES, GET_CURRENT_SEASON_DATE, GET_PREVIOUS_SEASON_DATE, GET_JKCSCHEDULEDRIDES, GET_FOStageQuery, GET_TNCTRAINERSENTRIES, GET_HORSE_FORMER_NAME, GET_SUMMARYQUERY, GET_CHANGES, GET_TIMEOFFSET
} from "@/app/utils/request/QIDSquery";

export const LANGCODE_EN = "en-us";
export const LANGCODE_CT = "zh-hk";

export const CMS = "cms";
export const QIDS = "qids";


export type LangCode = typeof LANGCODE_EN | typeof LANGCODE_CT;

// import mockFooterMenu from '../../../../public/test_data/FooterMenu.json';
// import mockRGPBanner from '../../../../public/test_data/RGPBanner.json';
// import mockHeader from '../../../../public/test_data/Header.json';
// import mockHeaderNavMain from '../../../../public/test_data/HeaderNavMain.json';
// import mockRemark from '../../../../public/test_data/remark.json';
// import mockSpeedguide from 'public/test_data/speedpro/json/speedguide/index.json';
// import mockFormguide from 'public/test_data/speedpro/json/formguide/index.json';
// import mockTrainerEntries from 'public/test_data/TrainersEntirs.json';
// import mockTNCTrainerEntries from 'public/test_data/TNCTrainersEntirs.json';
// import mockHorseFormerName from 'public/test_data/horseformername.json';
// import mockSummary from '../../../../public/test_data/Summary.json';
// import mockgetFOStage from '../../../../public/test_data/getFOStage.json';
// import mockJockeyRides from '../../../../public/test_data/JockeyRides.json';
import { getCmsDomain } from "../Common";

//Get CMS Date
export const getFooterMenu = async (
  options: any
) => {
  const variables = { path: "/sitecore/content/Sites/JCRW/SiteConfiguration/Footer", ...options };
  return await fetchRequest(variables, GET_FOOTER_MENU, CMS);
};

export const getRGPBanner = async (
  options: any
) => {
  const variables = { path: "/sitecore/content/Sites/CorpWebCommon/RGP/02-Racing", ...options };
  return await fetchRequest(variables, GET_RGPBANNER, CMS);
};

export const getHeader = async (
  options: any
) => {
  const variables = { path: "/sitecore/content/Sites/JCRW/SiteConfiguration/Header", ...options };
  return await fetchRequest(variables, GET_HEADER, CMS);
};

export const getHeaderNavMain = async (
  options: any
) => {
  const variables = { path: "/sitecore/content/Sites/CorpWebCommon/InformationArchitercutre/", ...options };
  return await fetchRequest(variables, GET_HEADER_NAV_MAIN, CMS);
};

// export const GET_Remark_User = async (
//   options: any,
//   pageName: any
// ) => {
//   const variables = { path: "/sitecore/content/Sites/JCRW/Local/Remarks/"+pageName, ...options };
//   return await fetchRequest(variables, GET_REMARK, CMS, mockRemark);
// };

// export const GET_Remark_Additional_Remark = async (
//   options: any,
//   pageName: any
// ) => {
//   const variables = { path: "/sitecore/content/Sites/JCRW/Local/Remarks/"+pageName, ...options };
//   return await fetchRequest(variables, GET_REMARKANDADDITIONALREMARK, CMS, mockRemark);
// };

export const getLocalRemark = async (
  path: string,
  lang: string,
  hideAdditionalRemark: boolean
) => {
  let variables = {
    path: '',
    language: lang
  }
  let cmsPath = "/sitecore/content/Sites/JCRW/Local/Remarks/";
  variables.path = cmsPath + path;

  if(path=="TrainersEntries" || path=="JockeysRides")
  {
    const res_additional_remark = fetchRequest(variables, GET_REMARKANDADDITIONALREMARK, CMS);
    return Promise.all([res_additional_remark])
    .then((res:any) => {
      let remark = '';
      const [data] = res;
      if (data && data?.item) {
        if(hideAdditionalRemark)
        {
          remark = data?.item?.remarks?.rendered;
        }else{
          remark = data?.item?.remarks?.rendered + "<br/>" + data?.item?.additionalRemarks?.rendered;
        }
      }
      return remark;
    })
  }
  else{
    const res_user_remark = fetchRequest(variables, GET_REMARK, CMS) 
    return Promise.all([res_user_remark])
    .then((res:any) => {
      let remark = '';
      const [data] = res; 
      if (data && data?.item) {
        remark = data?.item?.remarks?.rendered;
      }
      return remark;
    })

  }

}


//Get QIDS Date
export const getJockeyRanking = async (season: string) => {
  const variables = {
    season: season
  };
  return await fetchRequest(variables, GET_JOCKEYRANKING, QIDS);
}

export const getTrainerRanking = async (season: string) => {
    const variables = {
      season: season
    };
  return await fetchRequest(variables, GET_TRAINERRANKING, QIDS);
}

export const getCurrentSeasonDate = async () => {
  const variables = {
    venueCodes: ["ST", "HV", "CH"]
  };
  return await fetchRequest(variables, GET_CURRENT_SEASON_DATE, QIDS);
}

export const getPreviousSeasonDate = async (locSim: string) => {
    const variables = {
      locSim: locSim 
    };
  return await fetchRequest(variables, GET_PREVIOUS_SEASON_DATE, QIDS);
}

export const getJockeysRides = async (
  meetingDate: any,
  // venCode: string
) => {
  const variables = {
    date: !meetingDate ? null : meetingDate?.replaceAll("/","-"), 
    // venueCode: venCode
  };
  return await fetchRequest(variables, GET_JOCKEYSRIDES, QIDS);
}

export const getTrainersEntries = async (
  meetingDate: any,
  // oddsTypes: any
) => {
  const variables = {
    dates: !meetingDate ? null : [meetingDate?.replaceAll?.("/","-")],
  };
  return await fetchRequest(variables, GET_TRAINERSENTRIES, QIDS);
}
export const getTNCTrainersEntries = async (
  meetingDate: any,
  // oddsTypes: any
) => {
  const variables = {
    dates: !meetingDate ? null : [meetingDate?.replaceAll?.("/","-")],
  };
  return await fetchRequest(variables, GET_TNCTRAINERSENTRIES, QIDS);
}

export const getHorseFormerName = async () => {
  const variables = {};
  return await fetchRequest(variables, GET_HORSE_FORMER_NAME, QIDS);
}

export const getJKCScheduledRides = async (
  meetingDate: string
) => {
  const variables = {
    dates: meetingDate,
    active: true
  };
  return await fetchRequest(variables, GET_JKCSCHEDULEDRIDES, QIDS);
}

export const getFOStage = async (
  meetingDate: string
) => {
  const variables = {
    "oddsTypes": [
      "TNC", "JKC"
    ],
    "pmPoolsOddsTypes2": ["WIN"],
    "dates": meetingDate? [meetingDate] : null
  };
  return await fetchRequest(variables, GET_FOStageQuery, QIDS);
}

export const getSpeedguide = async (options: any) => {
  // const variables = {};
  // return await fetchRequest(variables, "", CMS, mockSpeedguide, undefined, true);
  const path = `${getCmsDomain()}/-/media/Sites/JCRW/SpeedPro/current/sg_index`;
  let result = {} as any;
  await fetch(path)
    .then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error " + response.status);
      }
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        result = response.json();
      } else {
        throw new Error("Response error");
      }
    })
    .catch((err) => {
      console.error(err);
    });
  return result;
};

export const getSpeedguideByRaceNo = async (raceNo: string) => {
  // const variables = {};
  // const mockFile = require(`public/test_data/speedpro/json/speedguide/race_${raceNo}.json`)
  // return await fetchRequest(variables, "", CMS, mockFile, undefined, true);

  const path = `${getCmsDomain()}/-/media/Sites/JCRW/SpeedPro/current/sg_race_${raceNo}`;
  let result = null;
  await fetch(path)
    .then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error " + response.status);
      }
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        result = response.json();
      } else {
        throw new Error("Response error");
      }
    })
    .catch((err) => {
      console.error(err);
    });
  return result;
};

export const getFormguideByRaceNo = async (raceNo: string) => {
  const path = `${getCmsDomain()}/-/media/Sites/JCRW/SpeedPro/current/fg_race_${raceNo}`;
  let result = null;
  await fetch(path)
    .then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error " + response.status);
      }
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        result = response.json();
      } else {
        throw new Error("Response error");
      }
    })
    .catch((err) => {
      console.error(err);
    });
  return result;
};

export const getSummaryInfo = async (
  meetingDate: string
) => {
  const variables = {
    dates: !meetingDate ? null : [meetingDate?.replaceAll?.("/","-")],
  };
  return await fetchRequest(variables, GET_SUMMARYQUERY, QIDS);
};

export const getChanges = async (
  meetingDate: string
) => {
  const variables = {
    dates: meetingDate,
    active: true
  };
  return await fetchRequest(variables, GET_CHANGES, QIDS);
}
 
export const getBusinessDate = async () => {
  return await fetchRequest(null, GET_TIMEOFFSET, QIDS);
};

export const getGoingReport = async (
  languageCode: string
) => {
  const variables = { 
    path: "/sitecore/content/Sites/JCRW/Local/RaceMeetingReminder", 
    language: languageCode
  };
  return await fetchRequest(variables, GET_GoingReport, CMS);
};